import React, {
  Component,
} from 'react';

class Confirmation extends Component {
  render() {
    return (
      <div className="confirmationContainer">
        CONFIRMATION
      </div>
    );
  }
}

export default Confirmation;



/** WEBPACK FOOTER **
 ** ./src/pages/confirmation/index.js
 **/